import axios from "axios";
import AddToCart from "../general/addtocart";

let busy = false;
export default class Category {
    constructor() {
        if (document.getElementById('pageCategory') !== null) {
            this.initPageLinks();
            this.initFilters();
            this.initSort();
            this.setMeta();
            this.initMore();

            window.addEventListener('popstate', e => {
                this.updatePage(document.location, false);
            });
        }
    }

    initPageLinks() {
        const pageLinks = document.querySelectorAll('.page-link');

        pageLinks.forEach(pageLink => {
            pageLink.addEventListener('click', e => {
                e.preventDefault();

                let span = document.createElement("span")
                span.classList.add('loader', 'loader-secondary');
                pageLink.append(span);

                this.updatePage(pageLink.href);
            });
        });
    }

    initFilters() {
        const filterContainer = document.getElementById('filterContainer');
        if (filterContainer) {
            const filters = document.getElementById('filters');
            const brandItems = filters.querySelectorAll('ul.brands li a');
            const filterItems = filters.querySelectorAll('ul.filters li a');
            const removeFilters = filters.querySelectorAll('.remove');
            const activeFilters = document.querySelectorAll('#activeFilters a');
            let button = document.querySelector('.btn-filters');
            let close = filters.querySelector('.close');

            document.addEventListener('click', e => {
                let button = document.querySelector('.btn-filters');
                let close = filters.querySelector('.close');

                if (close.contains(e.target) || (!filters.contains(e.target) && !button.contains(e.target))) {
                    document.body.classList.remove('filter-open');
                    filters.classList.remove('open');

                    setTimeout(function () {
                        filterContainer.classList.remove('open');
                    }, 300);
                }
            });

            close.addEventListener('click', e => {
                e.preventDefault();
            });

            button.addEventListener('click', e => {
                e.preventDefault();
                document.body.classList.add('filter-open');
                filterContainer.classList.add('open');
                setTimeout(function () {
                    filters.classList.add('open');
                }, 300);
            });

            brandItems.forEach(brandItem => {
                brandItem.addEventListener('click', e => {
                    e.preventDefault();

                    if (!busy) {
                        brandItem.querySelector('span').classList.add('loader');
                    }

                    this.updatePage(brandItem.href);
                });
            });

            filterItems.forEach(filterItem => {
                filterItem.addEventListener('click', e => {
                    e.preventDefault();
                    if (!busy) {
                        filterItem.querySelector('span').classList.add('loader');
                    }

                    this.updatePage(filterItem.href);
                });
            });

            removeFilters.forEach(removeItem => {
                removeItem.addEventListener('click', e => {
                    e.preventDefault();
                    this.updatePage(removeItem.href);
                });
            });

            activeFilters.forEach(filter => {
                filter.addEventListener('click', e => {
                    e.preventDefault();

                    let span = document.createElement("span")
                    span.classList.add('loader', 'loader-secondary');
                    filter.querySelector('i').append(span);

                    this.updatePage(filter.href);
                });
            });
        }
    }

    initSort() {
        const dropdown = document.getElementById('sort');
        const button = dropdown.querySelector('.btn');
        let list = button.nextElementSibling;
        let sortLinks = list.querySelectorAll('a');

        sortLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();

                let span = document.createElement("span")
                span.classList.add('loader', 'loader-secondary');
                button.querySelector('i').append(span);

                list.classList.remove('visible');

                this.updatePage(link.href);
            });
        });

        button.addEventListener('click', e => {
            list.classList.toggle('visible');
        });

        document.addEventListener('click', e => {
            let isClickInside = dropdown.contains(e.target);

            if (!isClickInside) {
                list.classList.remove('visible');
            }
        });
    }

    setMeta() {
        const pagination = document.querySelector('.pagination');

        if (document.querySelector('head link[rel=prev]')) {
            document.querySelector('head link[rel=prev]').remove();
        }
        if (document.querySelector('head link[rel=next]')) {
            document.querySelector('head link[rel=next]').remove();
        }

        if (pagination) {
            if (pagination.dataset.relPrev) {
                let linkPrev = document.createElement('link');
                linkPrev.setAttribute('rel', 'prev');
                linkPrev.setAttribute('href', pagination.dataset.relPrev);
                document.querySelector('head').append(linkPrev);
            }

            if (pagination.dataset.relNext) {
                let linkNext = document.createElement('link');
                linkNext.setAttribute('rel', 'next');
                linkNext.setAttribute('href', pagination.dataset.relNext);
                document.querySelector('head').append(linkNext);
            }
        }
    }

    initMore() {
        const more = document.querySelector('.more');
        const content = document.getElementById('content');
        if(more) {
            more.addEventListener('click', e => {
                e.preventDefault();

                content.scrollIntoView();
            });
        }
    }

    updatePage(href, pushState = true) {
        if (!busy) {
            if(pushState) {
                window.history.pushState({}, null, href);
            }

            const pageContent = document.getElementById('pageContent');
            const filterContainer = document.getElementById('filterContainer');
            let categoryHeader;

            if (this.source) {
                this.source.cancel();
            }
            this.CancelToken = axios.CancelToken;
            this.source = this.CancelToken.source();

            busy = true;

            axios({
                method: 'post',
                url: href,
                cancelToken: this.source.token
            })
                .then(response => { // success
                    if (filterContainer) {
                        filterContainer.classList.remove('open');
                        filterContainer.innerHTML = response.data[1];
                    }

                    pageContent.innerHTML = response.data[0];
                    this.initFilters();
                    this.initPageLinks();
                    this.initSort();
                    new AddToCart();
                    this.setMeta();

                    categoryHeader = document.getElementById('categoryHeader');
                    categoryHeader.scrollIntoView();
                })
                .catch(error => { // error
                    // console.log(error);
                })
                .then(() => { // always
                    this.source = null;
                    busy = false;
                    document.body.classList.remove('filter-open');
                });
        }
    }
}
